import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/feedback.svg'


const _withScopeId = n => (_pushScopeId("data-v-71243b26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = { class: "bg-primary-50 h-12rem" }
const _hoisted_3 = { class: "flex flex-column wp1200 justify-content-center align-items-center h-full gap-3 sm:flex-row sm:justify-content-start" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-6rem"
}, null, -1))
const _hoisted_5 = { class: "text-4xl font-semibold sm:text-5xl" }
const _hoisted_6 = { class: "flex flex-column gap-3 wp1200 py-4" }
const _hoisted_7 = { class: "flex flex-column gap-3 -mt-6 border-1 border-gray-200 border-round-2xl p-3 bg-white sm:p-0 sm:border-none sm:mt-0" }
const _hoisted_8 = { class: "flex gap-3 flex-column sm:flex-row" }
const _hoisted_9 = { class: "p-float-label rounded-input icon error-label mb-0 flex-1 w-full" }
const _hoisted_10 = { for: "search" }
const _hoisted_11 = { class: "flex align-items-center justify-content-center gap-2 w-full" }
const _hoisted_12 = {
  key: 0,
  class: "flex gap-3 flex-column sm:flex-row w-full"
}
const _hoisted_13 = {
  class: "flex-1 relative",
  style: {"min-width":"0"}
}
const _hoisted_14 = {
  key: 0,
  class: "grid"
}
const _hoisted_15 = { class: "sm:col col-12 flex flex-column gap-3 flex-order-1 sm:flex-order-0" }
const _hoisted_16 = { class: "flex justify-content-center h-1rem" }
const _hoisted_17 = { class: "text-sm text-gray-800" }
const _hoisted_18 = { class: "flex flex-column gap-3" }
const _hoisted_19 = { class: "col flex flex-column gap-3 flex-order-0 sm:flex-order-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1rem hidden sm:block" }, null, -1))
const _hoisted_21 = { class: "bg-primary-50 border-round-3xl px-4" }
const _hoisted_22 = { class: "font-semibold mb-3" }
const _hoisted_23 = {
  class: "w-full bg-yellow-500 border-round-3xl",
  style: {"height":"8px"}
}
const _hoisted_24 = { class: "flex align-items-center justify-content-center gap-4 my-3" }
const _hoisted_25 = { class: "flex align-items-center gap-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block bg-primary-600 border-circle w-1rem h-1rem" }, null, -1))
const _hoisted_27 = { class: "mt-1 text-gray-800 text-base" }
const _hoisted_28 = { class: "flex align-items-center gap-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block bg-yellow-500 border-circle w-1rem h-1rem" }, null, -1))
const _hoisted_30 = { class: "text-base mt-1 text-gray-800" }
const _hoisted_31 = { class: "map" }
const _hoisted_32 = { class: "map-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconSearch = _resolveComponent("IconSearch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconFilter = _resolveComponent("IconFilter")!
  const _component_IconChevronDown = _resolveComponent("IconChevronDown")!
  const _component_IconChevronUp = _resolveComponent("IconChevronUp")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_IconClose = _resolveComponent("IconClose")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_FeedbackCard = _resolveComponent("FeedbackCard")!
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("public_feedback.title")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("i", null, [
              _createVNode(_component_IconSearch)
            ]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              id: "search",
              maxlength: "255",
              onKeyup: _withKeys(_ctx.getFeedbacks, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]),
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("public_feedback.search")), 1)
          ]),
          _createVNode(_component_Button, {
            class: "button secondary w-full sm:w-fit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_IconFilter),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("public_feedback.hide_filters")), 1),
                (_ctx.showFilters)
                  ? (_openBlock(), _createBlock(_component_IconChevronDown, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_IconChevronUp, { key: 1 }))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "button primary w-full sm:w-fit hidden sm:block",
            label: _ctx.$t('public_feedback.submit'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'FeedbackSubmit' })))
          }, null, 8, ["label"])
        ]),
        (_ctx.showFilters)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_MultiSelect, {
                modelValue: _ctx.selectedLocalCommunity,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLocalCommunity) = $event)),
                filter: "",
                display: "chip",
                "max-selected-labels": 3,
                options: _ctx.localCommunities,
                optionLabel: "name",
                optionValue: "id",
                placeholder: _ctx.$t('public_feedback.local_communities'),
                class: "flex-1",
                style: {"min-width":"0"},
                onChange: _cache[4] || (_cache[4] = () => _ctx.getFeedbacks()),
                "empty-filter-message": _ctx.$t('global.no_hits'),
                "filter-placeholder": _ctx.$t('global.search')
              }, null, 8, ["modelValue", "options", "placeholder", "empty-filter-message", "filter-placeholder"]),
              _createVNode(_component_MultiSelect, {
                modelValue: _ctx.selectedCategory,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCategory) = $event)),
                filter: "",
                display: "chip",
                "max-selected-labels": 3,
                options: _ctx.types,
                optionLabel: "name",
                optionValue: "id",
                placeholder: _ctx.$t('public_feedback.categories'),
                class: "flex-1",
                style: {"min-width":"0"},
                onChange: _cache[6] || (_cache[6] = () => _ctx.getFeedbacks()),
                "empty-filter-message": _ctx.$t('global.no_hits'),
                "filter-placeholder": _ctx.$t('global.search')
              }, null, 8, ["modelValue", "options", "placeholder", "empty-filter-message", "filter-placeholder"]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateRange) = $event)),
                  selectionMode: "range",
                  manualInput: false,
                  placeholder: _ctx.$t('public_feedback.dates'),
                  onDateSelect: _ctx.selectDateRange,
                  class: "w-full"
                }, null, 8, ["modelValue", "placeholder", "onDateSelect"]),
                (_ctx.dateRange.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "absolute bg-transparent border-none cursor-pointer",
                      style: {"right":"12px","top":"18px"},
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearDateRange && _ctx.clearDateRange(...args)))
                    }, [
                      _createVNode(_component_IconClose)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Divider, { class: "my-1 sm:hidden" }),
        _createVNode(_component_Button, {
          class: "button primary w-full sm:w-fit sm:hidden",
          label: _ctx.$t('public_feedback.submit'),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push({ name: 'FeedbackSubmit' })))
        }, null, 8, ["label"])
      ]),
      _createVNode(_component_Divider, { class: "my-2" }),
      (_ctx.feedbacks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("public_feedback.number_of_results")) + ": " + _toDisplayString(_ctx.feedbacks.total), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbacks.data, (feedback) => {
                  return (_openBlock(), _createBlock(_component_FeedbackCard, {
                    key: feedback.id,
                    feedback: feedback
                  }, null, 8, ["feedback"]))
                }), 128))
              ]),
              (_ctx.showLoadMore)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "bg-transparent border-none shadow-none hover:bg-transparent text-gray-900 text-base",
                    label: _ctx.$t('route_planner.show_more'),
                    onClick: _ctx.loadMore
                  }, null, 8, ["label", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("public_feedback.success_rate")), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: "h-full bg-primary-600 border-round-3xl",
                    style: _normalizeStyle({ width: _ctx.statisticsPercentage + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("public_feedback.completed")) + " (" + _toDisplayString(_ctx.statisticsPercentage) + "%)", 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("public_feedback.in_progress")) + " (" + _toDisplayString(100 - _ctx.statisticsPercentage) + "%)", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Map, {
                    markers: _ctx.markers,
                    center: _ctx.center,
                    zoom: _ctx.zoom,
                    onCenterChanged: _ctx.updateCenter,
                    onZoomChanged: _ctx.updateZoom,
                    "navigate-on-click": "",
                    "fit-markers": ""
                  }, null, 8, ["markers", "center", "zoom", "onCenterChanged", "onZoomChanged"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}